import React, { useState, useEffect } from 'react';
import { PencilIcon, TrashIcon, PlusIcon } from '@heroicons/react/24/outline';
import { obtenerSettings, guardarSettings } from '../../api'; // Ajusta la ruta si es distinta

const Settings = () => {
  const [businessName, setBusinessName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [addressLink, setAddressLink] = useState('');
  const [facebook, setFacebook] = useState('');
  const [instagram, setInstagram] = useState('');
  const [twitter, setTwitter] = useState('');
  const diasSemana = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday',
    'Friday', 'Saturday', 'Sunday'
  ];
  
  const defaultHours = diasSemana.reduce((acc, day) => {
    acc[day] = { open: "14:00", close: "22:00", closed: false };
    return acc;
  }, {});
  
  
  const [openingHours, setOpeningHours] = useState(defaultHours);
  

  // Cargar settings al montar
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await obtenerSettings();
        if (data) {
          setBusinessName(data.business_name || '');
          setPhone(data.phone || '');
          setEmail(data.email || '');
          setAddress(data.address || '');
          setAddressLink(data.address_link || '');
          setFacebook(data.facebook || '');
          setInstagram(data.instagram || '');
          setTwitter(data.twitter || '');
  
          let parsedHours;
          try {
            parsedHours = typeof data.opening_hours === 'string'
              ? JSON.parse(data.opening_hours)
              : data.opening_hours;
          } catch {
            parsedHours = {};
          }
  
          const merged = diasSemana.reduce((acc, day) => {
            const parsed = parsedHours?.[day];
            acc[day] = {
              open: parsed?.open || "14:00",
              close: parsed?.close || "22:00",
              closed: parsed?.closed || false
            };
            return acc;
          }, {});
          
  
          setOpeningHours(merged);
        }
      } catch (error) {
        console.error('Error al cargar settings:', error);
      }
    };
    fetchSettings();
  }, []);
  

  const handleHourChange = (day, type, value) => {
    setOpeningHours(prev => ({
      ...prev,
      [day]: {
        ...prev[day],
        [type]: value
      }
    }));
  };

  const handleSave = async e => {
    e.preventDefault();
    try {
      await guardarSettings({
        business_name: businessName,
        phone,
        email,
        address,
        address_link: addressLink,
        facebook,
        instagram,
        twitter,
        opening_hours: openingHours
      });
      alert('Settings saved successfully!');
    } catch (err) {
      console.error('Error al guardar settings:', err);
      alert('Failed to save settings.');
    }
  };

  return (
    <div className="p-6 bg-gray-800 text-gray-200 h-full overflow-auto">
      <h1 className="text-2xl font-semibold mb-6">Settings</h1>
      <form onSubmit={handleSave} className="space-y-8">
        <div className="grid grid-cols-2 gap-6">
          <div className="space-y-2">
            <label className="block text-sm">Business Name</label>
            <input type="text" value={businessName} onChange={e => setBusinessName(e.target.value)} className="w-full p-3 bg-gray-700 rounded" />
          </div>
          <div className="space-y-2">
            <label className="block text-sm">Phone Number</label>
            <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} className="w-full p-3 bg-gray-700 rounded" />
          </div>
          <div className="space-y-2">
            <label className="block text-sm">Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full p-3 bg-gray-700 rounded" />
          </div>
          <div className="space-y-2">
            <label className="block text-sm">Address</label>
            <input type="text" value={address} onChange={e => setAddress(e.target.value)} className="w-full p-3 bg-gray-700 rounded" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6">
          <div className="space-y-2">
          <label className="block text-sm">Embed Map URL (Google Maps)</label>
<input
  type="text"
  value={addressLink}
  onChange={e => setAddressLink(e.target.value)}
  className="w-full p-3 bg-gray-700 rounded"
  placeholder="https://www.google.com/maps/embed?pb=..."
/>

          </div>
          <div className="space-y-2">
            <label className="block text-sm">Facebook Link</label>
            <input type="url" value={facebook} onChange={e => setFacebook(e.target.value)} className="w-full p-3 bg-gray-700 rounded" />
          </div>
          <div className="space-y-2">
            <label className="block text-sm">Instagram Link</label>
            <input type="url" value={instagram} onChange={e => setInstagram(e.target.value)} className="w-full p-3 bg-gray-700 rounded" />
          </div>
          <div className="space-y-2">
            <label className="block text-sm">Twitter Link</label>
            <input type="url" value={twitter} onChange={e => setTwitter(e.target.value)} className="w-full p-3 bg-gray-700 rounded" />
          </div>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-light-gray mb-4">Opening Hours</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {Object.entries(openingHours).map(([day, time]) => (
  <div key={day} className="space-y-2 bg-gray-700 p-3 rounded">
    <div className="flex items-center justify-between">
      <label className="font-semibold text-light-gray">{day}</label>
      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={time.closed || false}
          onChange={e => {
            setOpeningHours(prev => ({
              ...prev,
              [day]: {
                ...prev[day],
                closed: e.target.checked,
              }
            }));
          }}
        />
        Closed
      </label>
    </div>

    {!time.closed && (
      <div className="flex gap-2">
        <input
          type="time"
          value={time.open}
          onChange={e => handleHourChange(day, 'open', e.target.value)}
          className="w-full bg-gray-800 p-2 rounded"
        />
        <input
          type="time"
          value={time.close}
          onChange={e => handleHourChange(day, 'close', e.target.value)}
          className="w-full bg-gray-800 p-2 rounded"
        />
      </div>
    )}
  </div>
))}

          </div>
        </div>

        <div className="flex justify-end pt-4 border-t border-gray-700">
          <button type="submit" className="px-6 py-2 bg-primary text-white rounded hover:bg-hover-bg">
            <PlusIcon className="h-5 w-5 inline-block mr-2" />Save Settings
          </button>
        </div>
      </form>
    </div>
  );
};

export default Settings;
